import React, { useRef, useState } from "react";
import Sidebar from "../sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../images/recipt _ Logo 1.png";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { LuDownload } from "react-icons/lu";
import axios from "axios";
import api from "../../api/axios";
import { toast } from "react-toastify";
function View() {
  const location = useLocation();
  const veiwData = location.state?.data || {};

  const navigate = useNavigate();
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [popup, setPopup] = useState(false);
  const [recieptPopup, setRecieptPopup] = useState(false);
  const [selectedReciept, setSelectedReciept] = useState([]);
  const [expendedRow, setExpendedRow] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [orderID, setOrderID] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const today = new Date();
  const date = today.toLocaleDateString("en-GB");
  const [activeButton, setActiveButton] = useState("Product");
  const [customerID, setCustomerID] = useState(null)

  const handlePopup = (customerid, orderid, projectid) => {
    setCustomerID(customerid)
    setOrderID(orderid)
    setProjectID(projectid)
    setPopup(true)
  };





  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const handleRecipt = (id) => {
    // const user = veiwData?.find((u) => u.orderDetails?.find((p) => p._id === id));

    const userOrder = veiwData.orderDetails.find((d) => d._id === id)

    setSelectedReciept({
      ...userOrder,
      firstName: veiwData.first_name,
      lastName: veiwData.last_name,
      gst_no: veiwData.gst_no,
      email: veiwData.email,
      mobile: veiwData.mobile
    })
    setRecieptPopup(true);

  };
  const subtotalprice = selectedReciept.usercart?.reduce(
    (acc, item) => acc + (Number(item.price) * Number(item.count) || 0),
    0
  );

  const closePopup = () => {
    setRecieptPopup(false);
  };
  const printRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!printRef.current) return;
    try {
      const style = document.createElement("style");
      style.innerHTML = ``;
      document.head.appendChild(style);
      // Generate canvas
      const canvas = await html2canvas(printRef.current, {
        scale: 4,
        useCORS: true,
        backgroundColor: "#ffffff",
        onclone: (documentClone) => {
          const clonedElement = documentClone.getElementById("printRefId");
          if (clonedElement) {
            clonedElement.style.fontFamily = "Arial, sans-serif";
            clonedElement.style.color = "black";
            clonedElement.style.border = "1px solid #000";
          }
        },
      });

      // Convert canvas to image
      const dataURL = canvas.toDataURL("image/png");

      // Create PDF
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Receipt.pdf");
      // Remove dynamically added styles after PDF generation
      document.head.removeChild(style);

      setRecieptPopup(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleExpendRow = (id) => {
    setExpendedRow((prev) => (prev === id ? null : id));
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files[0];

    setSelectedFile(file);
  };

  const handlePDFupload = async (e) => {
    e.preventDefault();
    setPopup(false);
    try {
      const formData = new FormData();
      formData.append("selectedFile", selectedFile);
      formData.append("date", date);
      await api.put(
        `/update/${projectID}/${orderID}/${customerID}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Certificate Upload successfull..");
      navigate("/customers");
    } catch (error) {
      console.error(error);
    }
  };

 

  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <i
                onClick={() => navigate("/customers")}
                className="fa-solid fa-arrow-left text-xl cursor-pointer"
              ></i>

              {/* <h1 className="font-medium 2xl:text-2xl text-xl">
                My Profile 👋🏼
              </h1> */}
            </div>
            {recieptPopup && (
              <>
                <div
                  onClick={closePopup}
                  className="fixed inset-0 flex flex-col top-0 left-0 w-screen h-screen z-[9999] items-center justify-center bg-black bg-opacity-50"
                >
                  <button
                    className="bg-[#C65B1D] px-4 py-1 rounded-md text-white mb-2"
                    onClick={handleDownloadPDF}
                  >
                    Downolad PDF
                  </button>
                  <div
                    ref={printRef}
                    className="bg-white border flex flex-col gap-10  shadow-lg  w-[556px] h-[800px]  py-16 px-6 max-w-6xl"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h2 className="text-sm font-semibold">
                          {selectedReciept.firstName} {selectedReciept.lastName}
                        </h2>
                        <p className="text-xs text-[#646464]">
                          GSTIN : <span>{selectedReciept.gst_no}</span>{" "}
                        </p>
                      </div>
                      <div>
                        <img className="w-[100px] h-[20px]" src={logo} alt="" />
                      </div>
                    </div>

                    <div className="text-xs">
                      <p className="text-[#505050]">
                        <span className="text-sm font-medium">
                          Payment Receipt :
                        </span>
                        Transaction Reference :{" "}
                        <span className="text-[#646464]">
                          {selectedReciept.razorpayPaymentId}
                        </span>{" "}
                      </p>
                      <p className="text-[#646464]">
                        This is a payment receipt for your transaction on
                        Project RenewCred-1
                      </p>
                    </div>

                    <div>
                      <h2 className="text-sm text-[#646464]">
                        AMOUNT PAID:
                        <span className="font-semibold text-sm">
                          ₹{" "}
                          {selectedReciept.finalPrice}
                        </span>
                      </h2>
                    </div>

                    <div className="grid grid-cols-2 text-[#646464] text-xs">
                      <div className="leading-5">
                        <p>ISSUED To</p>
                        <p>Email: {selectedReciept.email}</p>
                        <p>Mo: {selectedReciept.mobile}</p>
                      </div>
                      <div>
                        <p>PAID ON</p>
                        <p>{selectedReciept.orderdate}</p>
                      </div>
                    </div>
                    <div className="">
                      <table className="min-w-[100%] table-auto  shadow-sm border border-separate border-spacing-0">
                        <thead className="bg-[#f0f0f0] font-medium">
                          <tr>
                            <th className="py-1   text-[#646464] whitespace-nowrap   text-xs text-center border-b border-gray-300 ">
                              DESCRIPTION
                            </th>
                            <th className=" py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs text-center border-b border-gray-300">
                              UNIT PRICE
                            </th>
                            <th className="py-1 w-[20px] text-[#646464] whitespace-nowrap   text-xs  text-center border-b border-gray-300">
                              QTY
                            </th>

                            <th className="py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs  text-center border-b border-gray-300">
                              AMOUNT
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-xs font-normal">
                          {selectedReciept.usercart.map((product, index) => {
                            return (
                              <tr key={index}>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.projectname}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.price}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.count}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.price * product.count}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                      <div className="flex justify-end space-y-4 text-xs mb-10">
                        {/* Billing Summary Section */}
                        <div className="w-36 p-2 space-y-1">
                          <div className="flex justify-between items-center">
                            <p className="font-medium">Total:</p>
                            <p className="font-normal">
                              {subtotalprice}
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium text-[#00AC4F]">
                              Amount Paid:
                            </p>
                            <p className="font-normal text-[#00AC4F]">
                              ₹{" "}
                              {selectedReciept.finalPrice}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {popup && (
              <div className="fixed inset-0 top-0 left-0 w-screen h-screen z-[9999]  flex items-center justify-center bg-black bg-opacity-50">
                <form
                  onSubmit={handlePDFupload}
                  className="bg-white border rounded-[24px]  shadow-lg border-[#C65B1D] w-[556px]   p-10 max-w-6xl"
                >
                  <div className="text-end">
                    <i
                      onClick={() => setPopup(false)}
                      className="fa-solid fa-xmark text-lg cursor-pointer"
                    ></i>
                  </div>

                  <div className="text-center">
                    <h3 className="text-[#C65B1D] text-3xl font-medium">
                      Upload Doc
                    </h3>
                  </div>

                  <div
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={`border-2 border-dashed border-[#C65B1D] flex justify-center flex-col gap-4 items-center p-10 rounded-[20px] mt-10 ${dragActive ? "bg-orange-50" : ""
                      } cursor-pointer`}
                  >
                    <input
                      type="file"
                      accept=".png,.jpg,.jpeg,.pdf"
                      onChange={handleFileChange}
                      className="hidden"
                      id="fileInput"
                    />
                    <label
                      htmlFor="fileInput"
                      className="text-center cursor-pointer"
                    >
                      <i className="fa-solid fa-arrow-up-from-bracket text-[#686868] text-xl"></i>
                      <h3 className="text-[22px] mt-2">
                        Drag & drop or Browse
                      </h3>
                      <p className="text-[#B5B7C0] text-sm">
                        (Only PNG, JPG, PDF files allowed.)
                      </p>
                    </label>

                    {selectedFile && (
                      <p className="text-green-700 mt-4 text-sm">
                        Selected: {selectedFile.name}
                      </p>
                    )}
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="bg-[#C65B1D] w-full mt-10 p-2 rounded-lg text-white"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            )}
            <div className="border mt-5 flex flex-col gap-16 justify-start items-start 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="flex justify-center items-center gap-4 ">
                <i className="fa-solid fa-circle-user text-[50px]"></i>
                <div>
                  <h4 className="font-semibold text-xl">
                    {veiwData.first_name || "-"} {veiwData.last_name || "-"}
                  </h4>
                  <p className="text-xs text-[#757575]">
                    {veiwData.email || "-"}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-32">
                <div className="leading-10">
                  <p>name</p>
                  <p>Email</p>
                  <p>Company Name</p>
                  <p>Phone</p>
                  <p>Address</p>
                  <p>State</p>
                  <p>City</p>
                  <p>Pincode</p>
                  <p>Gst No</p>
                </div>
                <div className="leading-10 text-[#757575]">
                  <p>
                    {veiwData.first_name || "-"} {veiwData.last_name || "-"}
                  </p>
                  <p>{veiwData.email || "-"}</p>
                  <p>{veiwData.organization || "-"}</p>
                  <p>{veiwData.mobile || "-"}</p>
                  <p>{veiwData.address || "-"}</p>
                  <p>{veiwData.state || "-"}</p>
                  <p>{veiwData.city || "-"}</p>
                  <p>{veiwData.postcade || "-"}</p>
                  <p>{veiwData.gst_no || "-"}</p>
                </div>
              </div>
            </div>

            <div className="border 2xl:mt-5 mt-5 f  2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              {/* order table */}
              <div>
                <h3 className="text-md font-medium">Orders</h3>

                <section className="mt-2 overflow-x-auto">
                  <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                    <thead className="bg-[#FCFCFC] rounded-t-lg">
                      <tr className="">
                        <th
                          className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg w-[100px]  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8 border-[#E5E5E5]">
                            Order ID
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 pl-0 border-b w-[150px] border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Order Date
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Transaction ID
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap p-2  pl-0 w-[200px] border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Credits
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Total Amount
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="  border-[#E5E5E5]">
                            Receipt
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="  border-[#E5E5E5]"></div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-[#FFFFFF]">
                      {veiwData.orderDetails.map(
                        (payment, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                  {payment.razorpayOrderId}
                                </td>
                                <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                  {payment.orderdate}
                                </td>
                                <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                  {
                                    payment.razorpayPaymentId
                                  }
                                </td>
                                <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                  {payment.credits}
                                </td>
                                <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                  ₹ {payment.finalPrice}
                                </td>

                                <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                  <i
                                    onClick={() =>
                                      handleRecipt(
                                        payment._id
                                      )
                                    }
                                    className="fa-solid fa-download"
                                  ></i>
                                </td>

                                <td>
                                  <i
                                    onClick={() =>
                                      handleExpendRow(index)
                                    }
                                    className={`fa-solid ${expendedRow === index
                                      ? "fa-minus"
                                      : "fa-plus"
                                      }  cursor-pointer`}
                                  ></i>
                                </td>
                              </tr>
                              {expendedRow === index && (
                                <>
                                  <tr>
                                    <td colSpan="12">
                                      <div className="flex gap-6 mt-2">
                                        <table className="min-w-[100%] my-2 table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                          <thead className="bg-[#FCFCFC] rounded-t-lg">
                                            <tr className="">
                                              <th
                                                className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                              >
                                                <div className="border-r pr-8 border-[#E5E5E5]">
                                                  Project ID
                                                </div>
                                              </th>
                                              <th
                                                className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                              >
                                                <div className="border-r pr-8  border-[#E5E5E5]">
                                                  Project
                                                  Name
                                                </div>
                                              </th>
                                              <th
                                                className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                              >
                                                <div className="border-r pr-8  border-[#E5E5E5]">
                                                  Methodology
                                                </div>
                                              </th>
                                              <th
                                                className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                              >
                                                <div className="border-r pr-8  border-[#E5E5E5]">
                                                  Credits
                                                  (Tones)
                                                </div>
                                              </th>

                                              <th
                                                className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                              >
                                                <div className="border-r pr-8  border-[#E5E5E5]">
                                                  Unit Price
                                                </div>
                                              </th>
                                              <th
                                                className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                              >
                                                <div className="border-r pr-8  border-[#E5E5E5]">
                                                  Amount
                                                </div>
                                              </th>
                                              <th
                                                className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-center `}
                                              >
                                                <div className="  border-[#E5E5E5]">
                                                  Certificate
                                                </div>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {payment.usercart.map(
                                              (
                                                user,
                                                index
                                              ) => {
                                                const filename =
                                                  user.certificateURL
                                                    ?.split(
                                                      "-"
                                                    )
                                                    .pop();

                                                return (
                                                  <tr
                                                    key={
                                                      index
                                                    }
                                                  >
                                                    <td className="pl-4">
                                                      {
                                                        user.projectid
                                                      }
                                                    </td>
                                                    <td className="pl-0">
                                                      {
                                                        user.projectname
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        user.methodology
                                                      }
                                                    </td>
                                                    <td className="pl-0">
                                                      {
                                                        user.count
                                                      }
                                                    </td>

                                                    <td className="pl-0">
                                                      {
                                                        user.price
                                                      }
                                                    </td>
                                                    <td className="pl-0">
                                                      {user.price *
                                                        user.count}
                                                    </td>
                                                    <td className="pl-0 text-center">
                                                      {filename ? (
                                                        <button
                                                          onClick={() =>
                                                            user.certificateURL &&
                                                            window.open(
                                                              user.certificateURL,
                                                              "_blank"
                                                            )
                                                          }
                                                          className="text-[#0167FF] text-xl"
                                                        >
                                                          <LuDownload />
                                                        </button>
                                                      ) : (
                                                        <button
                                                          onClick={() => {
                                                            handlePopup(
                                                              veiwData._id,
                                                              payment._id,
                                                              user._id
                                                            );
                                                          }}
                                                          className="bg-[#F9EFE8] text-[#C65B1D] rounded-[4px] cursor-pointer font-medium px-2 py-[0.15rem]"
                                                        >
                                                          Upload
                                                        </button>
                                                      )}
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </React.Fragment>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </section>
              </div>

              {/* Download */}
              {/* <div className="mt-6">
                <h3 className="text-md font-medium">Downloads</h3>
                <section className="mt-2 overflow-x-auto">
                  <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                    <thead className="bg-[#FCFCFC] rounded-t-lg">
                      <tr className="">
                        <th
                          className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8 border-[#E5E5E5]">
                            File Name
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Date
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Order ID
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="  border-[#E5E5E5]">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-[#FFFFFF]">
                      <tr>
                        <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300"></td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div> */}

              {/* Certificate */}
              {/* <div className="mt-6">
                <h3 className="text-md font-medium">Certificate</h3>
                <section className="mt-2 overflow-x-auto">
                  <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                    <thead className="bg-[#FCFCFC] rounded-t-lg">
                      <tr className="">
                        <th
                          className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8 border-[#E5E5E5]">
                            Certificate Name
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Date
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Order ID
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="  border-[#E5E5E5]">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-[#FFFFFF]">
                      {veiwData.payments.map((payment) => {
                        const filename = payment.selectedFile?.split("-").pop();
                        return (
                          <tr>
                            <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {filename}
                            </td>
                            <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.date || ""}
                            </td>
                            <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.order_id}
                            </td>
                            <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {filename ? (
                                <button
                                  onClick={() =>
                                    payment.selectedFile &&
                                    window.open(payment.selectedFile, "_blank")
                                  }
                                  className="text-[#C65B1D]"
                                >
                                  download
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    handlePopup(payment.id);
                                  }}
                                  className="text-[#C65B1D]"
                                >
                                  Upload
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </section>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default View;
